module.exports = __webpack_public_path__ + "404-error.4b18b8cb33c0066392e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404-error.png
// module id = 288
// module chunks = 1